import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    const url = `/tenants/${params.tenantID}/bioreq?paginate=true`

    return authenticated({
      url,
      method: 'get',
      params: params
    })
  },
  show({ tenantID, bioreqID }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}`,
      method: 'get'
    })
  },
  indexByUser(params) {
    const url = `/tenants/${params.tenantID}/bioreq/user?paginate=true`

    return authenticated({
      url,
      method: 'get',
      params: params
    })
  },
  store({ tenantID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq`,
      method: 'post',
      data
    })
  },
  update({ tenantID, bioreqID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}`,
      method: 'post',
      data
    })
  },
  destroy({ tenantID, bioreqID }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}`,
      method: 'delete'
    })
  },
  download({ tenantID, bioreqID }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}/download`,
      method: 'get'
    })
  },
  match({ tenantID, bioreqID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/bioreq/${bioreqID}/match`,
      method: 'post',
      data
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/bioreq-documents.js